export default {
    layout : {
        carregando: 'Carga...'
    }
}